import { render, staticRenderFns } from "./CustomerCartList.vue?vue&type=template&id=6671934e&scoped=true&"
import script from "./CustomerCartList.vue?vue&type=script&lang=js&"
export * from "./CustomerCartList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCartList.vue?vue&type=style&index=0&id=6671934e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6671934e",
  null
  
)

export default component.exports